import { render, staticRenderFns } from "./InfoTypeCheckbox.vue?vue&type=template&id=0403dd07&scoped=true"
import script from "./InfoTypeCheckbox.vue?vue&type=script&lang=js"
export * from "./InfoTypeCheckbox.vue?vue&type=script&lang=js"
import style0 from "./InfoTypeCheckbox.vue?vue&type=style&index=0&id=0403dd07&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0403dd07",
  null
  
)

export default component.exports